// Ref: https://reactjs.org/docs/context.html
import React from 'react';

const AppContext = React.createContext({
    posts: [],
    authors: [],
    tags: [],
    products: [],
    action: '',
    lastPage: '',
    page: '',
    pageData: {},
    // eslint-disable-next-line no-unused-vars
    dispatch: (_action, _data) => {},
    searchIndex: null,
    indexComplete: false,
    searchValue: '',
    t: () => {}, 
    dir: 'ltr'
});

export default AppContext;
